import './App.css';
import React, {useState, useRef, Suspense, useEffect} from 'react';
import Home from './pages/home/Home';
import Aoa from './pages/404/Aoa';
/* import About from './pages/about/About'; */
import Contacto from './pages/contacto/Contacto';
import Modal from './componentes/modal/Modal';
import Caso from './pages/caso/Caso';
/* import LangSwitch from './componentes/languageSwitch/langSwitch'; */
import {Route,Routes, useLocation} from 'react-router-dom';
import LoadingPage from './componentes/LoadingPage/loadingPage';

import Header from './componentes/header/Header';
import Navbar from './componentes/navbar/Navbar';
/* import Footer from './componentes/footer/Footer'; */

function App() {

  const [estadoModal,cambiaEstadoModal] = useState({type:null,on:false,id:null});
  const [pendingScrollTarget, setPendingScrollTarget] = useState(null);
  const mainRef = useRef(null);
  const expRef = useRef(null);
  const location = useLocation();
  const screen = window.screen.width;

  /*
    FIX 1: el scroll solo debe ejecutarse cuando el ref ya existe. Si el elemento
    todavía no está montado, no intentamos leer su posición.
  */
  const scrollToSection = (targetRef, offset = 90) => {
    const doScroll = () => {
      if (targetRef === 'reset') {
        window.scroll({ top: 0, behavior: 'smooth' });
        return;
      }

      if (!targetRef?.current) return;

      const el = targetRef.current.getBoundingClientRect().top;
      const scr = window.scrollY;
      const targ = scr + el - offset;

      window.scroll({ top: targ, behavior: 'smooth' });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(doScroll);
    });
  };

  const requestScroll = (target) => {
    setPendingScrollTarget(target);
  };

  /*
    FIX 2: centralizamos la decisión del scroll en un único lugar.
    El menú o la navbar solo indican la intención (ruta + bloque) y App decide
    cuándo ejecutar el scroll real. Además, 'Inicio' necesita un caso especial: si
    el destino es Home, se fuerza el top inmediato para evitar que un scroll previo
    de otra sección quede activo.
  */
  useEffect(() => {
    if (!pendingScrollTarget) return;

    if (pendingScrollTarget === 'reset') {
      window.scrollTo({ top: 0, behavior: 'auto' });
      setPendingScrollTarget(null);
      return;
    }

    const timeout = window.setTimeout(() => {
      if (pendingScrollTarget === 'main' && mainRef.current) {
        const top = mainRef.current.getBoundingClientRect().top + window.scrollY - 90;
        window.scroll({ top, behavior: 'smooth' });
      }

      if (pendingScrollTarget === 'exp' && expRef.current) {
        const top = expRef.current.getBoundingClientRect().top + window.scrollY - 90;
        window.scroll({ top, behavior: 'smooth' });
      }

      setPendingScrollTarget(null);
    }, 150);

    return () => window.clearTimeout(timeout);
  }, [location.pathname, pendingScrollTarget]);

  return (
    <div id="mainT">
      <Modal estado={estadoModal} cambiarEstado={cambiaEstadoModal}></Modal>
      {/* <LangSwitch></LangSwitch> */}
      {screen > 500 ? <Header scroll={(ref) => scrollToSection(ref)} requestScroll={requestScroll} refs={{ mainRef, expRef}} ></Header>:<Navbar scroll={(ref) => scrollToSection(ref)} requestScroll={requestScroll} refs={{ mainRef, expRef}}></Navbar>}
      {/* <Header scroll={scrollToworks}></Header>
      <Navbar scroll={scrollToworks}></Navbar> */}
      <Suspense fallback={<LoadingPage/>}>
        <Routes>
          <Route path='' element={<Home />}></Route>
          <Route path='/' element={<Home />}></Route>
          <Route path='/Home' element={<Home mainref={mainRef} />}></Route>
          {/* <Route path='/About' element={<About />}></Route> */}
          <Route path='/About' element={<Home secref={expRef} />}></Route>
          <Route path='/Contacto' element={<Contacto />}></Route>
          <Route path='/Casos/:id/:name' element={<Caso scroll={(ref) => scrollToSection(ref)} requestScroll={requestScroll} />}></Route>
          <Route path='*' element={<Aoa />}></Route>
        </Routes>
      </Suspense>
      {/* <Footer></Footer> */}
    </div>
  );
}

export default App;
